<template>
  <div class="box">
    <div class="news">
      <div class="new_left">
        <div class="topli">
          <div @click="changeTab(i,v,$event)" v-for="(v,i) of tabData" :key="i">
            {{ v.title }}
          </div>
        </div>
        <div class="text">办公电话：0311-67505869</div>
        <div class="text">办公邮箱：hebcyjigl@163.com</div>
        <div class="text">地址：河北省石家庄市西三庄街19号</div>
      </div>
      <div class="new_right">
        <div class="top">
          <img
            src="../../static/erweima.png"
            alt=""
            style="width: 100%; height: 100%"
          />
          <div class="bottext">
            官方微信<br />
            扫码关注
          </div>
        </div>
      </div>
    </div>
    <div class="line"></div>
    <div class="bottomtext" @click="windowOpen">翼ICP备 2022002401号</div>
  </div>
</template>

<script>
export default {
  name: "bottomNav",
  data() {
    return {
      tabIndex: 0,
      tabData: [{
        title: '网站首页',
        path: '/',
        params: {
          type: '',
          tabInd: 0
        }
      }, {
        title: '公司概况',
        path: '/aboutUs',
        params: {
          type: '',
          tabInd: 1
        }
      }, {
        title: '新闻中心',
        path: '/newsCenter',
        params: {
          type: 'xwzx',
          tabInd: 2
        }
      }, {
        title: '业务板块',
        path: '/business',
        params: {
          type: '',
          tabInd: 3
        }
      }, {
        title: '投资项目',
        path: '/product',
        params: {
          type: '',
          tabInd: 4
        }
      }, {
        title: '政策法规',
        path: '/newsCenter',
        params: {
          type: 'zcfg',
          tabInd: 5
        }
      }, {
        title: '公示公告',
        path: '/newsCenter',
        params: {
          type: 'gkgs',
          tabInd: 6
        }
      }, {
        title: '党建工作',
        path: '/newsCenter',
        params: {
          type: 'djgz',
          tabInd: 7
        }
      }, {
        title: 'OA办公',
        path: '/',
        params: {
          type: '',
          tabInd: 8
        }
      }, {
        title: '联系我们',
        path: '/contact',
        params: {
          type: '',
          tabInd: 9
        }
      }],
    };
  },
  methods: {
    windowOpen(){
      window.open('https://beian.miit.gov.cn/')
    },
    changeTab(num, v, $event) {
      if(v.title=='OA办公'){
        window.open('//47.93.12.207');
        return false;
      }
      this.tabIndex = num;
      this.$emit('checkTab', this.tabIndex)
      this.$router.push({path: v.path, query: v.params}, () => {
      }, () => {
      })
    },
  },
};
</script>

<style scoped lang="less">
.active {
  font-size: 1.125rem /* 18/16 */;
  font-weight: bold;
  color: #ffffff;
  line-height: 0rem /* 0/16 */;
  text-align: center;
  font-style: normal;
  text-decoration-line: underline;
  text-transform: none;
}
.box {
  // height: 64.375rem /* 1030/16 */;
  background-color: #0e1e44;
  margin: 0 auto;
  padding: 3.125rem /* 50/16 */ 0px;
  display: inline-block;
  min-width: 93.75rem /* 1500/16 */;
  width: 100%;
  padding-bottom: 30px;
  .line {
    width: 100%;
    border: 0.0625rem /* 1/16 */ solid #ffffff;
    opacity: 0.5;
    margin-top: 6.25rem /* 100/16 */;
  }
  .bottomtext {
    text-align: center;
    color: #fff;
    font-weight: 550;
    margin-top: 1.875rem /* 30/16 */;
    padding: 0 6.5rem /* 104/16 */;
    min-width: 93.75rem /* 1500/16 */;
    cursor: pointer;
  }
  .news {
    width: 93.75rem /* 1500/16 */;
    margin: 0 auto;
    height: 100%;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 6.5rem /* 104/16 */;
    min-width: 93.75rem /* 1500/16 */;
    .topli {
      display: flex;
      align-items: center;
      margin-bottom: 4.375rem;
    }

    .text {
      font-size: 1rem /* 16/16 */;
      color: #fff;
      margin-bottom: 1.25rem /* 20/16 */;
    }
    .topli div {
      cursor: pointer;
      color: #fff;
      font-size: 1rem /* 16/16 */;
      margin-right: 1.875rem /* 30/16 */;
    }
    .new_right {
      .top {
        width: 9rem /* 144/16 */;
        height: 9rem /* 144/16 */;
        background-color: #fff;
      }
      .bottext {
        font-size: 1rem /* 16/16 */;
        text-align: center;
        color: #fff;
        margin-bottom: 0.625rem /* 10/16 */;
      }
    }
  }
}
</style>
